import store from '../store'

import Cards from '../experience/world/Cards'

import gsap from 'gsap'
import ScrollTrigger from '../vendor/gsap/ScrollTrigger.js'
import { qsa } from '../utils'

gsap.registerPlugin(ScrollTrigger)

let isTouch = 'ontouchstart' in document.documentElement

export default class ScrollAnimations {
  constructor() {
    this.tween = null

    if (store.sniffer.isDevice) {
      this.createDevice()
    } else {
      this.createDesktop()      
    }
  }

  createDesktop() {
    let duration = 1.0
    let ease = 'power2.inOut'
    let end = '+=1500'
    let cards = new Cards()

    // Hide or show mouse icon
    ScrollTrigger.create({
      trigger: '#zero-fee',
      start: 'center center',
      toggleActions: 'play none reverse none',
      onEnter: () => {
        document.body.classList.add('on-move')
      },
      onLeaveBack: () => {
        document.body.classList.remove('on-move')
      },
    })    

    // Interpolate between the galaxy mode and the logo position particles    
    const tl1 = gsap.timeline()
    tl1.to(store.progress[0], {
      value: 1,
      ease: 'expo.inOut',
      duration,
    })        
    
    ScrollTrigger.create({
      animation: tl1,
      trigger: '#trade',
      start: 'center center',
      end,
      scrub: true,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      toggleActions: 'play none reverse none',
      onEnter: (e) => {
        gsap.to('.levels', { opacity: 1 })
        handleLevels(e.trigger)
        // console.log('TRADE - ENTER')
      },
      onEnterBack: (e) => {
        store.progress[2].value = 0
        // console.log('TRADE - ENTER BACK')
      },     
      onLeave: () => {
        store.progress[2].value = 1   
        // console.log('TRADE - LEAVE')
      },

      onLeaveBack: (e) => {
        gsap.to('.levels', { opacity: 0 })
        handleLevels(e.trigger)
        // console.log('TRADE - LEAVE BACK')
      },      
    })

    // Explode the logo positions into the kind of sun with rotating cards
    const tlCurl = gsap.timeline()
    tlCurl
      .to(store.progress[1], {
        value: 1,
        duration,
        ease,     
      })        
      .add(cards.animateIn(), 0)
        
    ScrollTrigger.create({
      animation: tlCurl,
      trigger: '#curl',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      scrub: true,
      toggleActions: 'play none reverse none',
      onEnter: (e) => {          
        handleLevels(e.trigger)
        // console.log('CURL - ENTER')
      },
      onEnterBack: () => {
        // console.log('CURL - ENTER BACK')
      },
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
        // console.log('CURL - LEAVE BACK')
      },
    })  


    // Interpolate on scroll the explosion planet and Venn diagram
    const tl2 = gsap.timeline()
      .to(store.progress[3], {
        value: 1,
        duration,
        ease,
      })
      .add(cards.scrubOut(), 0)
      
    ScrollTrigger.create({
      animation: tl2,
      trigger: '#curl',
      start: 'bottom-=10% center',
      end,
      scrub: true,
      toggleActions: 'play none reverse none',
    })    

    // Pin section text while venn diagram is shown
    ScrollTrigger.create({
      trigger: '#better',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      onEnter: (e) => {
        handleLevels(e.trigger)
      },
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }      
    })      

    // Interpolate to spheres rotating
    const tl3 = gsap.timeline()
    .to(store.progress[4], {
      value: 1,
      duration,
      ease,     
    })    
    ScrollTrigger.create({
      animation: tl3,
      trigger: '#save',
      start: 'top-=50% center',
      end,
      scrub: true,
      toggleActions: 'play none reverse none',
    })       

    // Pin section text
    ScrollTrigger.create({
      trigger: '#save',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      onEnter: (e) => {
        handleLevels(e.trigger)
      },    
      
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }      
    }) 
        
    // Interpolate to cube
    const tl4 = gsap.timeline()
    .to(store.progress[5], {
      value: 1,
      duration,
      ease,     
    })    
    ScrollTrigger.create({
      animation: tl4,
      trigger: '#save',
      start: 'bottom-=20% center',
      end,
      scrub: true,
      toggleActions: 'play none reverse none',
    })    

    // Pin text
    ScrollTrigger.create({
      trigger: '#private',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      onEnter: (e) => {
        store.progress[2].value = 0
        handleLevels(e.trigger)
      },

      onLeaveBack: (e) => {
        store.progress[2].value = 1           
        handleLevels(e.trigger)  
      },
    })
    
    // Animate to galaxy again
    const tl5 = gsap.timeline()
      .to(store.progress[6], {
        value: 1,
        duration,
        ease,
      })      
      
    ScrollTrigger.create({
      animation: tl5,
      trigger: '#private',
      start: 'center+=25% center',
      end,
      toggleActions: 'play none reverse none',
      scrub: true,
    })    

    // Pin text
    ScrollTrigger.create({
      trigger: '#trusted',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      onEnter: (e) => {
        handleLevels(e.trigger)
      },     
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }       
    })

    // Transform to terrain
    const tl6 = gsap.timeline()
      .to(store.progress[7], {
        value: 1,
        duration,
        ease,
      })            

    ScrollTrigger.create({
      animation: tl6,
      trigger: '#trusted',
      start: 'center+=5% center',
      end,
      toggleActions: 'play none reverse none',
      scrub: true,
    })  

    // Pin text
    ScrollTrigger.create({
      trigger: '#powered',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',
      onEnter: (e) => {
        handleLevels(e.trigger)
      },  
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }      
    })

    // Pin text
    ScrollTrigger.create({
      trigger: '#dflow',
      start: 'center center',
      end,
      pin: true,
      pinType: isTouch ? 'fixed' : 'transform',     
      onEnter: (e) => {
        handleLevels(e.trigger)
      },
      onLeave: () => {
        gsap.to('.levels', { opacity: 0 })
      },
      onEnterBack: () => {
        gsap.to('.levels', { opacity: 1 })
      },
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }      
    })                        

    // Move camera
    const tl7 = gsap.timeline()
      .to(store.camera.position, {
        y: -2,
        duration,
        ease: 'sine.inOut',
      })   

    ScrollTrigger.create({
      animation: tl7,
      trigger: '#dflow',
      start: 'center+=5% center',
      end,  
      scrub: true, 
    })         
  }

  createDevice() {
    let duration = 0.5
    let ease = 'expo'
    let cards = new Cards()
    let markers = true

    // Hide or show mouse icon
    ScrollTrigger.create({
      trigger: '#zero-fee',
      start: 'center center',
      toggleActions: 'play none reverse none',
      onEnter: () => {
        document.body.classList.add('on-move')
      },
      onLeaveBack: () => {
        document.body.classList.remove('on-move')
      },

      onEnterBack: () => {
        store.progress[2].value = 0

        this.tween = gsap.to(store.progress[0], {
          value: 0,
          ease,
          duration,
        })                
      }
    })    

    // Tween from galaxy to logo
    ScrollTrigger.create({
      trigger: '#trade',
      start: 'center-=35% center',
      end: 'bottom top+=40%',
      toggleActions: 'play none reverse none',
      // markers,
      onEnter: (e) => {
        gsap.to('.levels', { opacity: 1 })
        handleLevels(e.trigger)
        // console.log('TRADE - ENTER')

        this.tween = gsap.to(store.progress[0], {
          value: 1,
          ease,
          duration,
        })            
      },

      onLeave: () => {
        store.progress[2].value = 1   
        // console.log('TRADE - LEAVE')
      },

      onLeaveBack: (e) => {
        gsap.to('.levels', { opacity: 0 })
        handleLevels(e.trigger)
        
        // console.log('TRADE - LEAVE')
      },      

      onEnterBack: (e) => {
        // console.log('TRADE - ENTER BACK')

        this.tween = gsap.timeline()
          .to(store.progress[1], {
            value: 0,
            ease,
          })        
          .add(cards.animateOut(), 0)        
      },           
    })    

    // Explode the logo positions into the kind of sun with rotating cards        
    ScrollTrigger.create({
      trigger: '#curl',
      start: 'center-=40% center',
      end: 'center-=15% top+=10%',
      toggleActions: 'play none reverse none',
      // markers,
      onEnter: (e) => {          
        this.tween = gsap.timeline()
          .to(store.progress[1], {
            value: 1,
            ease,
          })        
          .add(cards.animateIn(), 0)

        handleLevels(e.trigger)
        // console.log('CURL - ENTER')
      },

      onLeave: () => {
        this.tween = gsap.timeline()
          .to(store.progress[3], {
          value: 1,
            duration,
            ease,
          })
          .add(cards.animateOut(), 0)
      },

      onEnterBack: () => {
        // console.log('CURL - ENTER BACK')

        this.tween = gsap.timeline()
          .to(store.progress[3], {
            value: 0,
            duration,
            ease,
          })
          .add(cards.animateIn(), 0)                
      },

      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
        // console.log('CURL - LEAVE BACK')
      },
    })      

    // Interpolate on scroll the explosion planet and Venn diagram
    ScrollTrigger.create({
      trigger: '#better',
      start: 'center center',
      // markers,
      onEnter: (e) => {
        // this.tween = gsap.timeline()
        //   .to(store.progress[3], {
        //     value: 1,
        //     duration,
        //     ease,
        //   })
        //   .add(cards.animateOut(), 0)

        handleLevels(e.trigger)
      },
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      },
      onEnterBack: (e) => {
        this.tween = gsap.to(store.progress[4], {
          value: 0,
          ease, 
        })        
      }
    })   

    // Spheres
    ScrollTrigger.create({
      trigger: '#save',
      start: 'center-=35% center',
      end: 'bottom top',
      // markers,
      onEnter: (e) => {
        handleLevels(e.trigger)

        this.tween = gsap.to(store.progress[4], {
          value: 1,
          ease, 
        })
      },    
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      },
      onEnterBack: (e) => {
        store.progress[2].value = 1

        this.tween = gsap.to(store.progress[5], {
          value: 0,
          ease, 
        })        
      } 
    })       

    // Cube
    ScrollTrigger.create({
      trigger: '#private',
      start: 'top center',
      // markers,
      onEnter: (e) => {
        store.progress[2].value = 0

        this.tween = gsap.to(store.progress[5], {
          value: 1,
          ease, 
        })

        handleLevels(e.trigger)
      },
      onLeaveBack: (e) => {
        // store.progress[2].value = 1           
        handleLevels(e.trigger)  
      },
      onEnterBack: (e) => {
        this.tween = gsap.to(store.progress[6], {
          value: 0,
          ease, 
        })                
      }
    }) 

    // Trusted
    ScrollTrigger.create({
      trigger: '#trusted',
      start: 'top center',
      // markers,
      onEnter: (e) => {
        handleLevels(e.trigger)

        this.tween = gsap.to(store.progress[6], {
          value: 1,
          ease, 
        })        
      },     
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      },
      onEnterBack: (e) => {
        this.tween = gsap.to(store.progress[7], {
          value: 0,
          ease, 
        })              
      }
    }) 

    // Powered
    ScrollTrigger.create({
      trigger: '#powered',
      start: 'top center',
      // markers,
      onEnter: (e) => {
        handleLevels(e.trigger)

        this.tween = gsap.to(store.progress[7], {
          value: 1,
          ease, 
        })              
      },  
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      }      
    }) 

    // Dflow
    ScrollTrigger.create({
      trigger: '#dflow',
      start: 'center center',
      end: 'center+=5% center-=15%',
      // markers,
      onEnter: (e) => {
        handleLevels(e.trigger)
      },  
      onLeaveBack: (e) => {
        handleLevels(e.trigger)  
      },
      onLeave: () => {
        gsap.to('.levels', { opacity: 0 })
      },
      onEnterBack: () => {
        gsap.to('.levels', { opacity: 1 })

        this.tween = gsap.to(store.camera.position, {
          y: 0,
          duration,
          ease: 'expo.inOut',
        })            
      },      
    })   
    
    // Move camera
    // Tsunami
    ScrollTrigger.create({
      trigger: '#tsunami',
      start: 'center-=20% center',
      // markers,
      onEnter: () => {
        this.tween = gsap.to(store.camera.position, {
          y: -2,
          duration,
          ease: 'expo.inOut',
        })           
      }
    })                   
  }
}

function handleLevels(el, dir) {
  let sections = [...qsa('.paginate')]
  let index = sections.indexOf(el)

  let children = qsa('.levels li')
  let current = children[index]

  children.forEach(el => el.classList.remove('active'))
  current.classList.add('active')
}